"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsFavorite } from "@workspace/frontend-ui";
import type { FC } from "react";
import useFavourite from "./hooks/useFavourite";

type Props = {
  gameId?: string;
  isFavourite?: boolean;
};

const FavouriteButton: FC<Props> = ({ gameId, isFavourite = false }) => {
  const favourite = useFavourite({ gameId, isFavourite });
  const { t } = useGamePageData();

  const label = favourite.isFavourite
    ? t("game.controls.favourite.remove", "Remove from favourites")
    : t("game.controls.favourite.add", "Add to favourites");

  return (
    <GameControlsFavorite
      data-testid="favourite-button"
      aria-label={label}
      isFavourite={favourite.isFavourite}
      onClick={favourite.submitFavourite}
    />
  );
};

export default FavouriteButton;
